import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, FindTranslatedKey, convertToNumber, deleteData, handleDateChange } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, FormButton, InputBox, SelectInputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const UserMaster = ({ menuText }) => {
    //--Inital State--//
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const GetGroupName = DropDownData('GetGroupName')
    const [filterData, setFilterData] = useState(initializeFilterData)
     
    const [formData, setFormData] = useState({
        userID:'',
        userCode: '',
        userName: '',
        password: '',
        address: '',
        groupName: '',
        bCode: '',
        mobileNo: '',
        emailID: '',
        pinCode: '',
        city: '',
        dateofJoining: '',
        vehicleType: '',
        vehicleNo: '',
        active: true,
       
    })

    //--Handle Clear Function--//
    const handleClear = () => {
        setFormData({
            userID: '',
            userCode: '',
            userName: '',
            password: '',
            address: '',
            groupName: '',
            bCode: '',
            mobileNo: '',
            emailID: '',
            pinCode: '',
            city: '',
            dateofJoining: '',
            vehicleType: '',
            vehicleNo: '',
            active: true,
        });
        filterData.SearchText = ''
        getUserMasterData()
        inputrefs.current['txtUserName'].focus();
    };

    //--handle Submit Function--//
    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/User/InsertUpdateUserMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    //--handle Delete Function--//
    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/User/DeleteUserMaster`, { userID: id }, getUserMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    //--handle Sorting Function--//
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    //--handle Edit Function--//
    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/User/EditUserMaster', { userID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }

    }

    //--Grid Data Fetch Function--//
    const getUserMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/User/ShowUserMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getUserMasterData(value);
    };

    //--Get State ANd city By Pincode--//

    const getStateAndCity = async (value) => {
        let data = await ApiCall('/api/AutoComplete/GetCountryStateCityPincodeWise', { 'Pincode': value })
        if (data.status === 'SUCCESS') {
            setFormData(prev => ({
                ...prev,
                city: data?.city
            }))
        } else {
            setFormData(prev => ({
                ...prev,
                city: ''
            }))
        }
    };

    useEffect(() => {
        getUserMasterData();
    }, [sortConfig])

    useEffect(() => {
        inputrefs.current['txtUserName'].focus();
        document.title = 'User Master'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText : FindTranslatedKey('User Master')}</h6>
                </div>

                <div className='card-body row'>

                    <div className='row'>

                        <InputBox
                            id="txtUserCode"
                            type="text"
                            label='User Code'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtUserName'].focus()
                                }
                            }}
                            inputrefs={inputrefs}
                            PlaceHolderText="System Generated"
                            name='UserCode'
                            value={formData.userCode}
                            disabled
                        />
                        <InputBox
                            id="txtUserName"
                            type="text"
                            label='User Name'
                            required={true}
                            PlaceHolderText="User Name"
                            maxLength='30'
                            value={formData.userName}
                            onChange={(e) => setFormData({ ...formData, userName: e.target.value })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtPassword'].focus()
                                }
                            }}
                        />
                        <InputBox
                            id="txtPassword"
                            type="password"
                            PlaceHolderText="Password"
                            label={'Password'}
                            required={true}
                            value={formData.password}
                            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtGroupName'].focus()
                                }
                            }}
                        />
                       
                        <SelectInputBox
                            id="txtGroupName"
                            value={formData.groupName}
                            label='Group Name'
                            required={true}
                            onChange={(e) => setFormData({ ...formData, groupName: e.target.value, vehicleNo: '', vehicleType: '' })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    if (formData.groupName === '8' || formData.groupName === '10') {
                                        inputrefs.current['txtVehicleNo'].focus()
                                    }
                                    else {
                                        inputrefs.current['txtBCode'].focus()
                                    }

                                }
                            }}
                        >
                            <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                            {GetGroupName?.data?.dataList?.map((item, index) =>
                                <option key={item.name + index} value={item.code}>{FindTranslatedKey(item.name)}</option>
                            )}
                        </SelectInputBox>
                        {formData.groupName === '8' || formData.groupName === '10' ? <>
                            <InputBox
                                id="txtVehicleNo"
                                label='Vehicle No'
                                PlaceHolderText='Vehicle No'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtVehicleType'].focus()
                                    }
                                }}
                                required={false}
                                inputrefs={inputrefs}
                                value={formData.vehicleNo}
                                onChange={(e) => setFormData({ ...formData, vehicleNo: e.target.value })}
                            />
                            <InputBox
                                id="txtVehicleType"
                                label='Vehicle Type'
                                PlaceHolderText='Vehicle Type'
                                name='Vehicle Type'
                                required={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBCode'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                value={formData.vehicleType}
                                onChange={(e) => setFormData({ ...formData, vehicleType: e.target.value })}
                            />

                        </> : <></>}


                       
                        <AutoCompleteBoxNew
                            label='Branch'
                            placeholder='Branch'
                            value={formData.bCode ? formData.bCode : ''}
                            onChange={
                                (event, newInputValue) => {
                                    newInputValue = newInputValue || '';
                                    if (event.type !== 'keydown') {
                                        setFormData({ ...formData, bCode: newInputValue,  })
                                       
                                    }
                                }}
                            maxLength='50'
                            required={true}
                            inputrefs={inputrefs}
                            id="txtBCode"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtMobileNo'].focus() };
                            }}
                            autocompleteType='GetBranch'
                        />

                        <InputBox
                            id="txtMobileNo"
                            PlaceHolderText="Mobile No"
                            autoComplete="off"
                            maxLength='10'
                            required={true}
                            label='Mobile No'
                            value={formData.mobileNo}
                            onChange={(e) => setFormData({ ...formData, mobileNo: convertToNumber(e.target.value) })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtEmailID'].focus()
                                }
                            }}
                        />
                        <InputBox
                            type="email"
                            id="txtEmailID"
                            label='Email ID'
                            required={true}
                            PlaceHolderText="Email ID"
                            maxLength='50'
                            name='EmailId'
                            value={formData.emailID}
                            onChange={(e) => setFormData({ ...formData, emailID: e.target.value })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtAddress'].focus()
                                }
                            }}
                        />
                        <InputBox
                            type="text"
                            id="txtAddress"
                            className="form-control"
                            PlaceHolderText="Address"
                            label='Address'
                            maxLength='200'
                            value={formData.address}
                            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtPinCode'].focus()
                                }
                            }}
                        />

                        <AutoCompleteBoxNew
                            label='Pin Code'
                            placeholder='Pin Code'
                            value={formData.pinCode ? formData.pinCode : ''}
                            onChange={
                                (event, newInputValue) => {
                                    newInputValue = newInputValue || '';
                                    if (event.type !== 'keydown') {
                                        setFormData({ ...formData, pinCode: newInputValue, city: '' })
                                        getStateAndCity(newInputValue ? newInputValue : '')
                                    }
                                }}
                            maxLength='50'
                            required={true}
                            inputrefs={inputrefs}
                            id="txtPinCode"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtCity'].focus() };
                            }}
                            autocompleteType='GetPinCode'
                        />

                        <AutoCompleteBoxNew
                            label='City'
                            placeholder='City'
                            value={formData.city ? formData.city : ''}
                            onChange={
                                (event, newInputValue) => {
                                    newInputValue = newInputValue || '';
                                    if (event.type !== 'keydown') {
                                        setFormData({ ...formData, city: newInputValue, })
                                    }
                                }}
                            maxLength='50'
                            required={true}
                            inputrefs={inputrefs}
                            id="txtCity"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDOJ'].focus() };
                            }}
                            contextKey={formData.pinCode}
                            autocompleteType='GetCity_PinCodeWise'
                        />
                        <DateBox
                            inputrefs={inputrefs}
                            label="Date Of Joining"
                            placeholder="Date Of Joining"
                            id='txtDOJ'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtActive'].focus()
                                };
                            }}
                            required={true}
                            selected={formData.dateofJoining === '' ? '' : new Date(formData.dateofJoining)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'dateofJoining')}
                        />
                     
                        <Switch
                            inputrefs={inputrefs}
                            label='Active'
                            checked={formData.active}
                            id='txtActive'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['btnSave'].focus()
                                };
                            }}
                            onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                        />

                    </div>

                    <div className='row pb-1 mt-2'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                await handleDownloadExcel('/api/User/ShowUserMaster', filterData, 'User Master')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear} />
                    </div>

                </div>

            </div>
            <Table handleEdit={handleEdit}
                handleDelete={handleDelete}
                PageName={'UserMaster'}
                loading={loading}
                handleFilter={() => {
                    getUserMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={result}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />

        </>
    )
}

export default UserMaster;